import React from 'react';
import PropTypes from 'prop-types';
import MuiTableCell from '@mui/material/TableCell';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    height: '50px',
    border: 'none',
    color: `${theme.colors.eyConfidentGrey}`,
    fontSize: '14px',
    padding: '4px 8px 4px 24px',
    fontWeight: 'bold',
    backgroundColor: '#FFF',
    width: '24px',
    borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
  },
});

class TableSelectCell extends React.Component {
  static propTypes = {
    /** Row index value */
    rowIndex: PropTypes.number,
    /** Column index value */
    colIndex: PropTypes.number,
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  render() {
    const { classes } = this.props;

    return <MuiTableCell className={classes.root} />;
  }
}

export default styled(TableSelectCell)(styles);
